<template>
  <div class="profile-container">
    <div class="profile-card">
      <h2>Mi Perfil</h2>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <div v-if="success" class="success-message">
        {{ success }}
      </div>
      
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="username">Usuario</label>
          <input 
            id="username" 
            v-model="username" 
            type="text" 
            disabled
          />
        </div>
        
        <div class="form-group">
          <label for="email">Correo Electrónico</label>
          <input 
            id="email" 
            v-model="email" 
            type="email" 
            required
          />
        </div>
        
        <div class="form-group">
          <label for="fullName">Nombre Completo</label>
          <input 
            id="fullName" 
            v-model="fullName" 
            type="text"
          />
        </div>
        
        <div class="form-group">
          <label for="password">Nueva Contraseña <small>(dejar en blanco para mantener la actual)</small></label>
          <input 
            id="password" 
            v-model="password" 
            type="password" 
            autocomplete="new-password"
          />
        </div>
        
        <div class="form-group" v-if="password">
          <label for="confirmPassword">Confirmar Contraseña</label>
          <input 
            id="confirmPassword" 
            v-model="confirmPassword" 
            type="password" 
            autocomplete="new-password"
          />
        </div>
        
        <button 
          type="submit" 
          :disabled="loading || (password && password !== confirmPassword)"
          class="btn-primary"
        >
          {{ loading ? 'Guardando...' : 'Guardar Cambios' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import apiClient from '../../api'

export default {
  name: 'ProfileView',
  setup() {
    const store = useStore()
    const username = ref('')
    const email = ref('')
    const fullName = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const loading = ref(false)
    const error = ref(null)
    const success = ref(null)
    
    // Cargar datos del perfil
    onMounted(async () => {
      loading.value = true
      try {
        const response = await apiClient.get('/auth/me')
        username.value = response.data.username
        email.value = response.data.email
        fullName.value = response.data.full_name || ''
      } catch (err) {
        error.value = 'Error al cargar el perfil'
        console.error(err)
      } finally {
        loading.value = false
      }
    })
    
    const handleSubmit = async () => {
      // Validación
      if (password.value && password.value !== confirmPassword.value) {
        error.value = 'Las contraseñas no coinciden'
        return
      }
      
      // Resetear mensajes
      error.value = null
      success.value = null
      loading.value = true
      
      try {
        // Preparar datos para la actualización
        const userData = {
          email: email.value,
          full_name: fullName.value
        }
        
        if (password.value) {
          userData.password = password.value
        }
        
        // Actualizar perfil
        await apiClient.put('/auth/me', userData)
        
        // Mostrar mensaje de éxito
        success.value = 'Perfil actualizado correctamente'
        
        // Limpiar campos de contraseña
        password.value = ''
        confirmPassword.value = ''
      } catch (err) {
        error.value = err.response?.data?.detail || 'Error al actualizar el perfil'
      } finally {
        loading.value = false
      }
    }
    
    return {
      username,
      email,
      fullName,
      password,
      confirmPassword,
      loading,
      error,
      success,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-container {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
}

.profile-card {
  width: 100%;
  max-width: 500px;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h2 {
    margin-bottom: 1.5rem;
    text-align: center;
    color: #333;
  }
}

.form-group {
  margin-bottom: 1rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    
    small {
      font-weight: normal;
      color: #718096;
    }
  }
  
  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    
    &:focus {
      outline: none;
      border-color: #4299e1;
    }
    
    &:disabled {
      background-color: #f7fafc;
      color: #718096;
    }
  }
}

.btn-primary {
  display: block;
  width: 100%;
  padding: 0.75rem;
  margin-top: 1.5rem;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background-color: #3182ce;
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.error-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  font-size: 0.875rem;
}

.success-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #c6f6d5;
  color: #2f855a;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>